import qs from 'qs';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { actionTypes, destroy } from 'redux-form';
import { applyDiscount } from '../lib/register';

// Actions
const OPEN = 'moblee/site-render/registerExtension/OPEN';
const PRE_ORDER_CHANGED = 'moblee/site-render/registerExtension/PRE_ORDER_CHANGED';
const SET_PRE_ORDER = 'moblee/site-render/registerExtension/SET_PRE_ORDER';
const SET_INSTALLMENTS = 'moblee/site-render/registerExtension/SET_INSTALLMENTS';
const NEXT_STEP = 'moblee/site-render/registerExtension/NEXT_STEP';
const EXPIRE = 'moblee/site-render/registerExtension/EXPIRE';
const RESTART = 'moblee/site-render/registerExtension/RESTART';
const SET_COUPON = 'moblee/site-render/registerExtension/SET_COUPON';

// Initial state
const initialState = {
  dialogOpen: false,
  currentStep: 0,
  ticketsCount: 0,
  subtotalValue: 0,
  couponCode:
    typeof window === 'undefined'
      ? undefined
      : qs.parse(window.location.search, { ignoreQueryPrefix: true }).coupon,
  coupon: undefined,
  totalValue: 0,
  installment: undefined,
};

// Helper functions
function calculateOrderValues(tickets, ticketTypesById, coupon) {
  let subtotalValue = 0;
  if (tickets) {
    Object.keys(tickets).forEach(ticketTypeId => {
      subtotalValue += tickets[ticketTypeId] * ticketTypesById[ticketTypeId].price;
    });
  }

  const totalValue = calculateOrderTotalValue(subtotalValue, coupon, tickets, ticketTypesById);

  return { subtotalValue, totalValue };
}

function calculateOrderTotalValue(subtotalValue, coupon, tickets, ticketTypesById) {
  if (!coupon || !tickets) {
    return subtotalValue;
  }
  let totalValue = 0;

  const ticketsWithDiscount = coupon.ticketTypeIds.length
    ? coupon.ticketTypeIds.filter(ticketTypeId => tickets.hasOwnProperty(ticketTypeId))
    : Object.keys(tickets);

  Object.keys(tickets).forEach(ticketTypeId => {
    const ticketPrice = ticketTypesById[ticketTypeId].price;
    const ticketQuantity = tickets[ticketTypeId];

    const ticketTotalValue = ticketsWithDiscount.includes(ticketTypeId)
      ? applyDiscount(coupon, ticketPrice)
      : ticketPrice;

    totalValue += ticketTotalValue * ticketQuantity;
  });

  return totalValue;
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case OPEN:
      return {
        ...state,
        dialogOpen: true,
        currentStep: 0,
        ticketsCount: 0,
        subtotalValue: 0,
        totalValue: 0,
        installment: undefined,
      };
    case NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + (state.currentStep === 1 && !state.totalValue ? 2 : 1),
      };
    case EXPIRE:
      return { ...state, currentStep: 4 };
    case RESTART:
      return {
        ...state,
        currentStep: 0,
        ticketsCount: 0,
        subtotalValue: 0,
        totalValue: 0,
        installment: undefined,
      };
    case PRE_ORDER_CHANGED:
      const { tickets, ticketTypesById } = action.payload;
      const ticketsCount = tickets ? Object.values(tickets).reduce((a, b) => a + b, 0) : 0;
      const { subtotalValue, totalValue } = calculateOrderValues(
        tickets,
        ticketTypesById,
        state.coupon,
      );
      return {
        ...state,
        ticketsCount,
        subtotalValue,
        totalValue,
      };
    case SET_PRE_ORDER:
      const { preOrder, preOrderTickets } = action.payload;
      return {
        ...state,
        preOrder,
        preOrderTickets,
        timeOffset: moment().diff(moment(preOrder.createdAt)),
      };
    case SET_INSTALLMENTS:
      const {
        installment: { __typename, interest, ...installment },
      } = action.payload;
      return { ...state, installment };
    case SET_COUPON:
      const { coupon } = action.payload;
      const values = calculateOrderValues(
        action.payload.tickets,
        action.payload.ticketTypesById,
        coupon,
      );
      return {
        ...state,
        coupon,
        subtotalValue: values.subtotalValue,
        totalValue: values.totalValue,
      };
    case actionTypes.DESTROY:
      if (action.meta.form.includes('order')) {
        setTimeout(() => {
          window.parent.postMessage('closeRegister', '*');
        }, 250);
        return { ...state, dialogOpen: false };
      }

      return state;
    default:
      if (action.operationName === 'publicCoupon' && action.result && state.couponCode) {
        const coupon = action.result.data && action.result.data.publicCoupon;
        return { ...state, coupon };
      }

      return state;
  }
}

// Action creators
export function openRegisterExtension() {
  return { type: OPEN };
}

export function preOrderChanged(tickets, ticketTypesById) {
  return { type: PRE_ORDER_CHANGED, payload: { tickets, ticketTypesById } };
}

export function setPreOrder(preOrder, preOrderTickets) {
  return { type: SET_PRE_ORDER, payload: { preOrder, preOrderTickets } };
}

export function setInstallments(installment) {
  return { type: SET_INSTALLMENTS, payload: { installment } };
}

export function nextRegisterExtensionStep() {
  return { type: NEXT_STEP };
}

export function expireRegisterExtension() {
  return { type: EXPIRE };
}

export function restartRegisterExtension() {
  return { type: RESTART };
}

export function closeRegisterExtension() {
  return destroy('order');
}

export function setCoupon(coupon, tickets, ticketTypesById) {
  return { type: SET_COUPON, payload: { coupon, tickets, ticketTypesById } };
}

// Selector
export function mapStateToProps(state) {
  return state.registerExtension;
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openRegisterExtension,
      preOrderChanged,
      setPreOrder,
      setInstallments,
      nextRegisterExtensionStep,
      expireRegisterExtension,
      restartRegisterExtension,
      closeRegisterExtension,
      setCoupon,
    },
    dispatch,
  );
}



// WEBPACK FOOTER //
// ./src/site-render/src/redux/registerExtension.js